import React from 'react';
import { CheckIcon as Check } from './Icons';

const UserPermissionSelector = ({ allUsers, selectedUserIds, onChange, label = "Bearbeitungsrechte" }) => {

    const toggleUser = (userId) => {
        let newSelection;
        if (selectedUserIds.includes(userId)) {
            newSelection = selectedUserIds.filter(id => id !== userId);
        } else {
            newSelection = [...selectedUserIds, userId];
        }
        onChange(newSelection);
    };

    return (
        <div className="md3-card-filled p-4 !bg-surface-containerLow border border-outlineVariant">
            <h3 className="text-title-medium font-bold mb-2 text-surface-on">{label}</h3>
            <p className="text-body-small text-surface-onVariant mb-4">
                Klicke auf die Personen, die Berechtigungen erhalten sollen.
            </p>

            <div className="flex flex-wrap gap-2">
                {allUsers && allUsers.length > 0 ? (
                    allUsers.map(u => {
                        const isSelected = selectedUserIds.includes(u._id);
                        return (
                            <button
                                key={u._id}
                                type="button"
                                onClick={() => toggleUser(u._id)}
                                className={`
                                    flex items-center gap-2 px-3 py-1.5 rounded-lg border transition-all select-none
                                    ${isSelected
                                        ? 'bg-primary-container border-primary text-primary-onContainer shadow-sm'
                                        : 'bg-surface border-outline text-surface-on hover:bg-surface-containerHigh'
                                    }
                                `}
                            >
                                <div className={`
                                    w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold uppercase
                                    ${isSelected ? 'bg-primary text-primary-on' : 'bg-surface-variant text-surface-onVariant'}
                                `}>
                                    {(u.userData?.scoutName || u.userData?.firstName || u.email || '?').slice(0, 2)}
                                </div>
                                <span className="text-label-large font-medium">{u.userData?.scoutName || u.userData?.firstName || u.email || 'Benutzer'}</span>
                                {isSelected && <Check size={16} className="text-primary-onContainer" />}
                            </button>
                        );
                    })
                ) : (
                    <p className="text-sm text-surface-onVariant italic">Keine Benutzer verfügbar.</p>
                )}
            </div>
        </div>
    );
};

export default UserPermissionSelector;
